var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "tabbar", staticClass: "emd-tabbar", class: _vm.classList },
    [
      _c(
        "ul",
        { staticClass: "emd-tabbar__list" },
        _vm._l(_vm.routesWizard, function (item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "emd-tabbar__item",
              class: { _disabled: !_vm.hasPermission(item, index) },
            },
            [
              _c(
                "a",
                {
                  staticClass: "emd-tabbar__link",
                  class: { _active: _vm.activeLink === item.component },
                  attrs: { id: "tabbarItem" + index },
                  on: {
                    click: function ($event) {
                      return _vm.changeRoute(item, index)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "emd-text _type_label _size_small eu-ml_1" },
                    [_vm._v(_vm._s(index + 1 + ". " + _vm.$t(item.component)))]
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }